import { Button } from "@mui/material";
import { Box } from "@mui/system";
import { useContext, useEffect, useState } from "react";
import { HexColorPicker, HexColorInput } from "react-colorful";
import SendToApi from "../../api/sendtoapi";
import globalStateContext from "../../globalstate/globalStateContext";

import "./styles.css";

export default function ColourPicker(props) {
  const { id } = props;
  const global = useContext(globalStateContext);

  useEffect(() => {
    if (global.userInfo[id]) {
      setColor(global.userInfo[id]);
    }
    return () => {
      console.log("leaving colour picker");
    };
  }, []);

  function onSetColour() {
    console.log({ id });
    console.log({ color });

    global.setUserInfo((prevState) => ({
      ...prevState,
      [id]: color,
    }));

    const setInfo = async () => {
      var values = {};
      values["colour1"] = global.userInfo.colour1;
      values["colour2"] = global.userInfo.colour2;
      values[id] = color;
      const result = await SendToApi("/users/setinfo", values);
      if (result) {
      }
    };
    // check if colours are dirty
    setInfo();
  }

  const [color, setColor] = useState("#aabbcc");
  return (
    <Box
      id="colour_picker"
      sx={{
        display: "flex",
        flexDirection: "row",
        m: "auto",
        width: "fit-content",
        gap: "1rem",
      }}
    >
      <HexColorPicker color={color} onChange={setColor} />
      <Box>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            width: "fit-content",
            alignContent: "flex-start",
          }}
        >
          <div id="prefix">#</div>
          <HexColorInput color={color} onChange={setColor} />
        </Box>
        <Button
          sx={{ marginTop: "1rem" }}
          disableRipple
          variant="contained"
          component="label"
          color="primary"
          size="medium"
          onClick={onSetColour}
        >
          Save
        </Button>
      </Box>
    </Box>
  );
}
